// extracted by mini-css-extract-plugin
module.exports = {"mobileFooter":"mobile-layout_mobileFooter__1R_p4","active":"mobile-layout_active__33nvo","mobileSection":"mobile-layout_mobileSection__1GGYt"};